import { render, staticRenderFns } from "./MonetariesTable.vue?vue&type=template&id=4c80b5d4&scoped=true&"
import script from "./MonetariesTable.vue?vue&type=script&lang=js&"
export * from "./MonetariesTable.vue?vue&type=script&lang=js&"
import style0 from "./MonetariesTable.vue?vue&type=style&index=0&id=4c80b5d4&prod&scoped=true&lang=css&"
import style1 from "./MonetariesTable.vue?vue&type=style&index=1&id=4c80b5d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80b5d4",
  null
  
)

export default component.exports